import { Box, Button, SimpleGrid, Stack } from "@chakra-ui/react";
import React from "react";
import { BiHomeAlt } from "react-icons/bi";
import { MdOutlinePersonOutline } from "react-icons/md";
import { RiFileTextLine } from "react-icons/ri";
import FooterButton from "../button/FooterButton";

export default function Footer() {
  const login = localStorage.getItem("access_token") !== null;
  return (
    <Box w="full" h="16" pos="fixed" bottom={0}>
      <SimpleGrid
        h="full"
        columns={login ? 3 : 2}
        bgColor="gray.100"
        p="5"
        justifyItems="center"
      >
        <FooterButton name="Beranda" link="/" Icon={BiHomeAlt} />
        {login && (
          <FooterButton
            name="Pesanan"
            link="/daftar-transaksi"
            Icon={RiFileTextLine}
          />
        )}
        <FooterButton
          name={login ? "Akun Saya" : "Masuk"}
          link={login ? "/akun" : "/login"}
          Icon={MdOutlinePersonOutline}
        />
      </SimpleGrid>
    </Box>
  );
}
